import { IInsightGraphFilterStatusData } from "types/ActionTrackerGraphs";
import { validateRequired } from "./validationUtils";

export function objDiff(tgt:any, src:any) {

    if (Array.isArray(tgt)) { // if you got array
        return tgt; // just copy it
    }

    // if you got object
    var rst:any = {};
    for (var k in tgt) { // visit all fields
        if (typeof src[k] === "object") { // if field contains object (or array because arrays are objects too)
            rst[k] = objDiff(tgt[k], src[k]); // diff the contents
        } else if (src[k] !== tgt[k]) { // if field is not an object and has changed
            rst[k] = tgt[k]; // use new value
        }
        // otherwise just skip it
    }
    return rst;
}

export function apiReady(src:any) {
    const nullableFields = ['comments', 'prepared_by_sign', 'attachments', 'blend_comments']
    const ignoredFields = ['attachments']
    const copySrc = {...src};
    for (var k in copySrc) {
        if (ignoredFields.indexOf(k) >= 0) {
            src[k] = null;
            continue;
        }
        if (typeof src[k] === "object") {
            src[k] = apiReady(src[k]);
        } else if (src[k] === "" && nullableFields.indexOf(k) < 0) {
            src[k] = null;
        }

    }
    return src;
}

export function convertNull2EmptyStr(src:any) {

    for (var k in src) {

        if (typeof src[k] === "object") {
            src[k] = convertNull2EmptyStr(src[k]);
        }
        if (src[k] === null) {
            src[k] = "";
        }

    }
    return src;
}

export function isEmpty(value:any) {
    return validateRequired(value);
}

export const isNotEmpty = (value:any) => {
    return validateRequired(value) === false;
}


export const filterDatafilterRelatedDataset = (
  data: IInsightGraphFilterStatusData[],
  primary_related_id: number | string ,
  secondary_related_id?: number | string,
  tertiary_related_id?: number | string
) => {
    if (!data || primary_related_id === '') return [];
    
    return data?.filter((item) => {
        if (tertiary_related_id !== undefined && tertiary_related_id !== '') {
            return item.primary_related_id === Number(primary_related_id) &&
                item.secondary_related_id === Number(secondary_related_id) &&
                item.tertiary_related_id === Number(tertiary_related_id);
        } else if (secondary_related_id !== undefined && secondary_related_id !== '') {
            return item.primary_related_id === Number(primary_related_id) &&
                item.secondary_related_id === Number(secondary_related_id);
        } else {
            return item.primary_related_id === Number(primary_related_id);
        }
    });
}